module.exports = __webpack_public_path__ + "static/img/wynum_02@2x.e77923a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wynum_02@2x.png
// module id = AYaw
// module chunks = 1